// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Icon__Jsx3 = require("../../atoms/Icon/Icon__Jsx3.bs.js");
var Responsive = require("../../helpers/Responsive.bs.js");
var Text__Jsx3 = require("../../helpers/Text__Jsx3.bs.js");
var View__Jsx3 = require("../../helpers/View__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Image__Jsx3 = require("../../atoms/Image/Image__Jsx3.bs.js");
var Theme__Color = require("../../../../reason/common/Theme/Theme__Color.bs.js");
var Heading__Jsx3 = require("../../helpers/Heading__Jsx3.bs.js");
var ContentBox__Jsx3 = require("../../atoms/ContentBox/ContentBox__Jsx3.bs.js");
var Theme__Color__Vars = require("../../../../reason/common/Theme/Theme__Color__Vars.bs.js");
var Colors = require("uikit/styles/colors");
var PriceAttribute__Jsx3 = require("../../atoms/PriceAttribute/PriceAttribute__Jsx3.bs.js");

function ConversationContextCard__Jsx3$TitleSection$HeadingWrapper(props) {
  return React.createElement(View__Jsx3.make, {
              alignItems: "flexStart",
              flexDirection: Responsive.make("column", "row", undefined, undefined, undefined, undefined, undefined),
              children: Caml_option.some(props.children)
            });
}

var HeadingWrapper = {
  make: ConversationContextCard__Jsx3$TitleSection$HeadingWrapper
};

function ConversationContextCard__Jsx3$TitleSection$Heading(props) {
  return React.createElement(Heading__Jsx3.make, {
              as_: "h4",
              mb: {
                NAME: "px",
                VAL: 5
              },
              mr: {
                NAME: "px",
                VAL: 10
              },
              children: props.children
            });
}

var Heading = {
  make: ConversationContextCard__Jsx3$TitleSection$Heading
};

function ConversationContextCard__Jsx3$TitleSection$Label(props) {
  return React.createElement(View__Jsx3.make, {
              mr: {
                NAME: "px",
                VAL: 10
              },
              mb: {
                NAME: "px",
                VAL: 5
              },
              children: Caml_option.some(props.children)
            });
}

var Label = {
  make: ConversationContextCard__Jsx3$TitleSection$Label
};

function ConversationContextCard__Jsx3$TitleSection$Subtitle(props) {
  return React.createElement(Text__Jsx3.make, {
              fontSize: {
                NAME: "px",
                VAL: 14
              },
              color: Colors.gray,
              children: props.children
            });
}

var Subtitle = {
  make: ConversationContextCard__Jsx3$TitleSection$Subtitle
};

function ConversationContextCard__Jsx3$TitleSection(props) {
  var subtitle = props.subtitle;
  var price = props.price;
  var label = props.label;
  var title = props.title;
  var tmp;
  if (title !== undefined) {
    var tit = Caml_option.valFromOption(title);
    if (subtitle !== undefined) {
      var sub = Caml_option.valFromOption(subtitle);
      tmp = label !== undefined ? React.createElement(React.Fragment, undefined, React.createElement(ConversationContextCard__Jsx3$TitleSection$HeadingWrapper, {
                  children: null
                }, React.createElement(ConversationContextCard__Jsx3$TitleSection$Heading, {
                      children: tit
                    }), React.createElement(ConversationContextCard__Jsx3$TitleSection$Label, {
                      children: Caml_option.valFromOption(label)
                    })), React.createElement(ConversationContextCard__Jsx3$TitleSection$Subtitle, {
                  children: sub
                })) : React.createElement(React.Fragment, undefined, React.createElement(ConversationContextCard__Jsx3$TitleSection$Heading, {
                  children: tit
                }), React.createElement(ConversationContextCard__Jsx3$TitleSection$Subtitle, {
                  children: sub
                }));
    } else {
      tmp = label !== undefined ? React.createElement(React.Fragment, undefined, React.createElement(ConversationContextCard__Jsx3$TitleSection$HeadingWrapper, {
                  children: null
                }, React.createElement(ConversationContextCard__Jsx3$TitleSection$Heading, {
                      children: tit
                    }), React.createElement(ConversationContextCard__Jsx3$TitleSection$Label, {
                      children: Caml_option.valFromOption(label)
                    }))) : React.createElement(ConversationContextCard__Jsx3$TitleSection$Heading, {
              children: tit
            });
    }
  } else if (subtitle !== undefined) {
    var sub$1 = Caml_option.valFromOption(subtitle);
    tmp = label !== undefined ? React.createElement(ConversationContextCard__Jsx3$TitleSection$HeadingWrapper, {
            children: null
          }, React.createElement(View__Jsx3.make, {
                mr: {
                  NAME: "px",
                  VAL: 10
                },
                children: Caml_option.some(React.createElement(ConversationContextCard__Jsx3$TitleSection$Subtitle, {
                          children: sub$1
                        }))
              }), React.createElement(ConversationContextCard__Jsx3$TitleSection$Label, {
                children: Caml_option.valFromOption(label)
              })) : React.createElement(ConversationContextCard__Jsx3$TitleSection$Subtitle, {
            children: sub$1
          });
  } else {
    tmp = label !== undefined ? React.createElement(ConversationContextCard__Jsx3$TitleSection$Label, {
            children: Caml_option.valFromOption(label)
          }) : null;
  }
  return React.createElement(View__Jsx3.make, {
              mb: {
                NAME: "px",
                VAL: 15
              },
              justifyContent: "spaceBetween",
              flexDirection: Responsive.make("column", undefined, "row", undefined, undefined, undefined, undefined),
              flexBasis: {
                NAME: "percent",
                VAL: 100
              },
              children: Caml_option.some(null)
            }, React.createElement(View__Jsx3.make, {
                  alignItems: "flexStart",
                  justifyContent: "flexStart",
                  flexDirection: Responsive.make("column", undefined, undefined, "row", undefined, undefined, undefined),
                  children: Caml_option.some(React.createElement(View__Jsx3.make, {
                            mb: {
                              NAME: "px",
                              VAL: 10
                            },
                            flexDirection: "column",
                            children: Caml_option.some(tmp)
                          }))
                }), price !== undefined ? React.createElement(View__Jsx3.make, {
                    ml: Responsive.make({
                          NAME: "px",
                          VAL: 0
                        }, undefined, {
                          NAME: "px",
                          VAL: 30
                        }, undefined, undefined, undefined, undefined),
                    children: Caml_option.some(React.createElement(PriceAttribute__Jsx3.make, {
                              value: price
                            }))
                  }) : null);
}

var TitleSection = {
  HeadingWrapper: HeadingWrapper,
  Heading: Heading,
  Label: Label,
  Subtitle: Subtitle,
  make: ConversationContextCard__Jsx3$TitleSection
};

function ConversationContextCard__Jsx3$MediaSection(props) {
  return React.createElement(View__Jsx3.make, {
              flexDirection: Responsive.make("column", undefined, undefined, "row", undefined, undefined, undefined),
              flexGrow: 1,
              flexBasis: {
                NAME: "percent",
                VAL: 100
              },
              children: Caml_option.some(null)
            }, props.image, React.createElement(View__Jsx3.make, {
                  flexDirection: "column",
                  flexGrow: 1,
                  flexBasis: {
                    NAME: "percent",
                    VAL: 100
                  },
                  children: Caml_option.some(props.content)
                }));
}

var MediaSection = {
  make: ConversationContextCard__Jsx3$MediaSection
};

function ConversationContextCard__Jsx3$ContentSection(props) {
  return React.createElement(View__Jsx3.make, {
              p: {
                NAME: "px",
                VAL: 15
              },
              flexDirection: "column",
              flexGrow: 1,
              flexBasis: {
                NAME: "percent",
                VAL: 100
              },
              children: Caml_option.some(props.children)
            });
}

var ContentSection = {
  make: ConversationContextCard__Jsx3$ContentSection
};

function ConversationContextCard__Jsx3$PropertyImage(props) {
  return React.createElement(Image__Jsx3.make, {
              width: Responsive.make({
                    NAME: "percent",
                    VAL: 100
                  }, undefined, undefined, {
                    NAME: "px",
                    VAL: 175
                  }, undefined, undefined, undefined),
              height: Responsive.make({
                    NAME: "px",
                    VAL: 130
                  }, {
                    NAME: "px",
                    VAL: 175
                  }, undefined, "auto", undefined, undefined, undefined),
              src: props.src,
              alt: props.alt
            });
}

var PropertyImage = {
  make: ConversationContextCard__Jsx3$PropertyImage
};

function ConversationContextCard__Jsx3$LockedSection(props) {
  return React.createElement(View__Jsx3.make, {
              alignItems: "center",
              flexDirection: "row",
              children: Caml_option.some(null)
            }, React.createElement(Icon__Jsx3.make, {
                  icon: /* Lock */47,
                  color: Theme__Color__Vars.gray
                }), React.createElement(View__Jsx3.make, {
                  ml: {
                    NAME: "px",
                    VAL: 5
                  },
                  children: Caml_option.some(props.children)
                }));
}

var LockedSection = {
  make: ConversationContextCard__Jsx3$LockedSection
};

function ConversationContextCard__Jsx3(props) {
  return React.createElement(ContentBox__Jsx3.make, {
              paddingNone: true,
              hasShadow: true,
              hasBorder: true,
              children: Caml_option.some(React.createElement(View__Jsx3.make, {
                        alignItems: "flexStart",
                        flexDirection: "row",
                        flexGrow: 0,
                        position: "relative",
                        backgroundColor: Theme__Color.white,
                        children: Caml_option.some(props.children)
                      }))
            });
}

var View;

var $$Text;

var Icon;

var $$Image;

var ContentBox;

var PriceAttribute;

var responsive = Responsive.make;

var make = ConversationContextCard__Jsx3;

exports.View = View;
exports.$$Text = $$Text;
exports.Icon = Icon;
exports.$$Image = $$Image;
exports.ContentBox = ContentBox;
exports.PriceAttribute = PriceAttribute;
exports.responsive = responsive;
exports.TitleSection = TitleSection;
exports.MediaSection = MediaSection;
exports.ContentSection = ContentSection;
exports.PropertyImage = PropertyImage;
exports.LockedSection = LockedSection;
exports.make = make;
/* react Not a pure module */
